/**
 * @file Shared React component — components/common/OutlineButton.tsx.
 */

// src/components/common/OutlineButton.tsx
import React from "react";
import "./OutlineButton.css";

interface OutlineButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
}

const OutlineButton: React.FC<OutlineButtonProps> = ({
  label,
  onClick,
  type = "button",
  disabled,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="outline-btn"
    >
      {label}
    </button>
  );
};

/** React component — Outline Button. */
export default OutlineButton;

